import styled from 'styled-components';
import { rgba } from 'polished';
import { primary, neutral, white } from '../../../../style/colors';

export const Container = styled.div`
  background: linear-gradient(to bottom, ${white} 0%, ${neutral[50]} 100%);
  border-bottom: 1px solid ${neutral[200]};
  padding: 20px 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`;

export const SearchSection = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
`;

export const InputWrapper = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  border: 1.5px solid ${neutral[200]};
  border-radius: 12px;
  padding: 12px 18px;
  background-color: ${white};
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

  &:focus-within {
    border-color: ${primary[500]};
    box-shadow: 0 0 0 3px ${rgba(primary[500], 0.1)};
  }

  &:hover {
    border-color: ${neutral[300]};
  }

  i:first-child {
    color: ${neutral[400]};
    font-size: 20px;
    transition: color 0.2s;
  }

  &:focus-within i:first-child {
    color: ${primary[500]};
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  background: transparent;
  color: ${neutral[900]};
  margin-left: 12px;

  &::placeholder {
    color: ${neutral[400]};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${neutral[400]};
  transition: all 0.2s;
  border-radius: 4px;
  
  &:hover {
    background: ${neutral[100]};
    color: ${neutral[500]};
  }
  
  &:active {
    transform: scale(0.95);
  }

  i {
    font-size: 18px;
  }
`;

export const SearchButton = styled.button`
  background: ${primary[500]};
  color: ${white};
  border: none;
  padding: 12px 28px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px ${rgba(primary[500], 0.25)};
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px ${rgba(primary[500], 0.35)};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: none;
  }

  i {
    font-size: 18px;
  }
`;

export const LoadingSpinner = styled.i`
  animation: spin 0.8s linear infinite;
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
